export default "__VITE_ASSET__96e3448e__"